import React from "react";
import { Button } from "reactstrap";
import style from "./Zaposlenici.module.scss";
import Table from "../Table/Table";
import FormModal from "./FormModal";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteModal from "./DeleteModal";
import { useStateMachine } from "little-state-machine";
import updateAction from "./updateAction";
import { handlePostRequest } from "../../helpers/handle-response";
import { useQuery, useMutation, queryCache } from "react-query";
import { formatZaposlenik } from "../../helpers/functions";

const Zaposlenici = ({ user, aktToAdd, size }) => {
  const [rowToEdit, setRowToEdit] = React.useState(0);
  const [rowToDelete, setRowToDelete] = React.useState({});

  const [modals, setModals] = React.useState({
    Delete: false,
  });
  const [open, setOpen] = React.useState({ from: "", state: false });
  const { action, state } = useStateMachine(updateAction);

  const [reqError, setReqError] = React.useState({ state: false, message: "" });
  const { status, data, error, isLoading, isFetching, refetch } = useQuery(
    "zaposlenici",
    async () => {
      const {
        data,
      } = await handlePostRequest(
        "https://building.plc.hr/api/c?m=ZaposlenikGets",
        [{ user: "igor", orgID: user.orgID }]
      );
      const parsedData = JSON.parse(data);
      const formatData = Object.keys(parsedData)
        .map((key) => parsedData[key])
        .filter((item) => {
          if (new Date(item.Deleted) <= new Date(2000, 0, 1)) {
            return true;
          } else return null;
        });
      console.log(formatData);
      return formatData;
    },
    {
      retry: (failureCount, error) => {
        if (error === "Retry") {
          console.log(failureCount, error);
          return true;
        }
      },
    }
  );

  const [addZaposlenik] = useMutation(
    async (dataToAdd) => {
      const z = {
        ...dataToAdd,
        ID: open.from === "edit" ? rowToEdit : 0,
        OrganizationID: user.orgID,
        Deleted: "",
        isDeleted: false,
        CreateIP: "",
        CreateTime: new Date(),
        CreateUser: user.username,
      };
      const res = await handlePostRequest(
        "https://building.plc.hr/api/c?m=ZaposlenikAddEdit",
        [{ user: "igor", z }]
      );
      return res;
    },
    {
      onSuccess: (data) => {
        console.log("is success", { isFetching, isLoading, data });
      },
      onError: (error) => {
        console.log(error);
      },
      onSettled: (res) => {
        if (res.data === "False") {
          queryCache.invalidateQueries("zaposlenici");
          setReqError({ state: true, message: "Pogreška. Pokušajte ponovo" });
          setTimeout(() => {
            setReqError({ state: false, message: "" });
          }, 2000);
        } else {
          // refetch();
          queryCache.invalidateQueries("zaposlenici");
          // FIX CLOSE MODAL
          if (open.state) {
            setOpen({ ...open, state: false });
          }
        }
      },
    }
  );
  const [deleteZaposlenik] = useMutation(
    async () => {
      const res = await handlePostRequest(
        "https://building.plc.hr/api/c?m=ZaposlenikDelete",
        [{ user: "igor", ID: rowToDelete.ID }]
      );
      return res;
    },
    {
      onSettled: (res) => {
        if (res.data === "False") {
          queryCache.invalidateQueries("zaposlenici");
          setReqError({ state: true, message: "Pogreška. Pokušajte ponovo" });
          setTimeout(() => {
            setReqError({ state: false, message: "" });
          }, 2000);
        } else {
          // refetch();
          queryCache.invalidateQueries("zaposlenici");
          if (modals.Delete && !isFetching) {
            setModals({ ...modals, Delete: false });
          }
        }
      },
    }
  );
  const cols = React.useMemo(
    () => [
      /*   {
        accessor: "Struka",
        className: "alignCenter",
        Header: "Struka",
      }, */
      {
        accessor: "Ime",
        className: "alignCenter",
        Header: "Ime",
        colClass: style.alignCenter,
      },
      {
        accessor: "Prezime",
        Header: "Prezime",
        className: "alignCenter",
        colClass: style.alignCenter,
      },
      {
        accessor: "OIB",
        className: "alignCenter",
        Header: "OIB",
        colClass: style.alignCenter,
      },
      {
        accessor: "Struka",
        Header: "Struka",
        className: "alignCenter",
        colClass: style.alignCenter,
      },
      {
        accessor: "RazinaObrazovanja",
        className: "alignCenter",
        Header: "Razina obrazovanja",
        colClass: style.alignCenter,
      },
      {
        Header: "Stručna titula",
        accessor: "StrucnaTitula",
        className: "alignCenter",
        colClass: style.alignCenter,
      },
      {
        Header: "Znanstvena titula",
        accessor: "ZnanstvenaTitula",
        className: "alignCenter",
        colClass: style.alignCenter,
      },

      {
        accessor: "Uredi",
        Header: "Uredi",
        className: "alignCenter",
        disableSortBy: true,
        disableCaret: true,
        Cell: (props) => {
          if (props)
            return (
              <button
                className={style.editButton}
                type="button"
                onClick={(e) => {
                  setRowToEdit(props.row.original.ID);
                  const data = formatZaposlenik(props.row.original);
                  console.log(props.row.original, data);
                  action(data);
                  setOpen({ state: true, from: "edit" });
                }}
              >
                <i className="far fa-edit"></i>
              </button>
            );
          return null;
        },
      },
      {
        accessor: "Obrisi",
        Header: "Obriši",
        disableSortBy: true,
        className: "alignCenter",
        disableCaret: true,
        Cell: (props) => {
          if (props)
            return (
              <button
                className={style.deleteButton}
                type="button"
                onClick={() => {
                  setModals({ ...modals, Delete: true });
                  setRowToDelete(props.row.original);
                }}
              >
                <i className="far fa-trash-alt"></i>
              </button>
            );
          return null;
        },
      },
    ],
    [modals, action]
  );

  return (
    <>
      {status === "loading" ? (
        <div className="d-flex mx-auto justify-content-center mt-2">
          <CircularProgress size="4rem" color="primary" />
        </div>
      ) : (
        <div>
          <div className="main-content">
            <section className={style.buttons}>
              <Button
                color="primary"
                onClick={() => {
                  setOpen({ state: !open.state, from: "add" });
                  action({
                    Ime: "",
                    OIB: "",
                    Prezime: "",
                    RazinaObrazovanja: "",
                    StrucnaTitula: "",
                    Struka: "",
                    ZnanstvenaTitula: "",
                    ovg: null,
                    oie: null,
                  });
                }}
              >
                Dodaj novog
              </Button>
            </section>

            <Table
              columns={cols}
              initialSort={[{ id: "Prezime", desc: false }]}
              data={data}
            ></Table>
          </div>
        </div>
      )}
      <FormModal
        size={size}
        open={open}
        setOpen={setOpen}
        aktToAdd={aktToAdd}
        addZaposlenik={addZaposlenik}
        user={user}
      />
      <DeleteModal
        open={modals}
        setOpen={setModals}
        rowToDelete={rowToDelete}
        deleteZaposlenik={deleteZaposlenik}
      ></DeleteModal>
    </>
  );
};

export default Zaposlenici;
